import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * v5 — Portail plein écran.
 *
 * Rend ses enfants directement dans document.body, HORS de l'arbre DOM du
 * composant appelant (ex: le panier). Ainsi, aucun ancêtre portant
 * transform / will-change / filter / backdrop-filter / perspective / contain
 * ne peut créer un "containing block" qui enfermerait un position:fixed.
 *
 * C'est le correctif robuste contre le bug intermittent où une popup
 * `fixed inset-0` s'affiche confinée dans la zone du panier au lieu de
 * couvrir tout l'écran.
 *
 * Usage :
 *   <Portal>
 *     <div className="fixed inset-0 z-[9999]">…</div>
 *   </Portal>
 */
export const Portal: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;
  return createPortal(children, document.body);
};

export default Portal;
